// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum InkStyle {
  VariableWidth = 0,
  FixedWidth = 1,
  Dash = 2,
  Dots = 3
}
